export default __webpack_public_path__ + "5b09af7ede56bad2fe3f6e1ca5e75b49.png";